import { LeafNodeValue } from "./decisionProcesses.dto";
import { LogicalOperator } from "./explanation.dto";

export enum Outcome {
  TRUE = "TRUE",
  FALSE = "FALSE",
  UNDECIDED = "UNDECIDED",
  UNKNOWN = "DONT_KNOW",
}

export interface Representation {
  question: string;
  name: string;
  logicalOperator: LogicalOperator;
  subConditions?: Representation[];
  value?: Outcome;
  propagateWhen?: LeafNodeValue[] | null;
  isInternallyEvaluated?: boolean;
  reasoning?: string;
}

export interface Tree {
  id: string;
  name: string;
  description: string;
  preferenceRank: number;
  template: Representation;
}

/**
 * Alias for Tree - used in product recommendation contexts.
 */
export type ProductTree = Tree;
